// extracted by mini-css-extract-plugin
export default {"close_button":"ForgotPassword_close_button__KrXVH","form_footer":"ForgotPassword_form_footer__W1LGH","text":"ForgotPassword_text__yLd4G"};